<template>
  <job-container ref="jobContainer" :list-data="compRecruitInfos" @onPullingDown="onPullingDown" @onPullingUp="onPullingUp">
    <template slot="container">
      <div class="job-list" v-if="!awaitLoadingShow">
        <!--        <cube-scroll ref="scroll" :data="compRecruitInfos" :options="options" @pulling-down="onPullingDown"-->
        <!--                     @pulling-up="onPullingUp">-->
        <div class="search-list">
          <div class="content" style="margin-top: 0" v-if="!wechatAllNetApplicationOpened">
            <div>
              <span class="title">网申提醒</span>
              <span class="desc">第一时间接收名企网申信息</span>
            </div>
            <button class="theme-btn" @click="campusStart">开启</button>
          </div>
          <div class="content" @click="toCampusBlog">
            <p class="prompt">超级会员专属<span class="gift">『{{ new Date().getFullYear() }}}求职大礼包』</span>，速来领取</p>
          </div>
          <!--            <div class="search-img">-->
          <!--              <img @click="toSearch" class="search-input" src="https://files.wondercv.com/jobs/search.png" alt="">-->
          <!--            </div>-->
          <div class="type-content">
            <cube-scroll :data="categories" direction="horizontal" class="horizontal-scroll-list-wrap">
              <ul class="category-container list-wrapper flex-start">
                <li class="type-item list-item" :class="{'type-item-active': index === currentIndex }"
                    v-for="(item, index) in categories" :key="index" @click="changeCategory(item, index)">{{item}}
                </li>
              </ul>
            </cube-scroll>
          </div>
          <div class="the-line"></div>
          <job-list-campus :list-data="compRecruitInfos" @toDetail="toDetail" @collection="collection"/>
          <w-more-loading v-show="loadingShow"/>
          <w-no-more v-show="isEnd"/>
        </div>
        <!--        </cube-scroll>-->
      </div>
      <w-loading v-else/>
    </template>
  </job-container>
</template>

<script>
	import jobContainer from '../job-components/job-container'
	import WLoading from '../../components/global/w-loading'
	import jobListCampus from '../job-components/job-list-campus'
	import WMoreLoading from '../../components/global/w-more-loading'
	import WNoMore from '../../components/global/w-no-more'
	import { campusMixin } from '../../assets/js/mixin/jobs'
	import { envMixin, loginMixin, windowEventMixin } from '../../assets/js/mixin/global'
	import { componentsMixin } from '../../assets/js/mixin/components'

	export default {
		name: 'campus-list',
		mixins: [ campusMixin, envMixin, loginMixin, componentsMixin, windowEventMixin ],
		data () {
			return {
				currentIndex: -1,
				categories: [],
				compRecruitInfos: [],
				wechatAllNetApplicationOpened: false,
				loadingShow: true,
				awaitLoadingShow: true,
				loadingOver: false,
				isEnd: false,
				page: 1,
				options: {
					pullDownRefresh: {
						txt: '刷新成功'
					},
					pullUpLoad: true
				}
			}
		},
		watch: {
			currentIndex () {
				this._getCampusList()
			}
		},
		beforeRouteEnter (to, from, next) {
			next(vm => {
				vm.refreshPageData(from.name)
			})
		},
		mounted () {
			this.$route.meta.shareByWx('名企精英都在用的的智能工具，收藏查看各大行业和公司动态，全网最新名企网申信息，让找工作的成功率翻倍！', { title: `收藏丨${new Date().getFullYear()} 最新校招汇总` })
		},
		computed: {},
		components: {
			jobContainer,
			jobListCampus,
			WLoading,
			WMoreLoading,
			WNoMore
		},
		methods: {
			// 校招职位搜索
			toSearch () {
				this.routeTo('/jobs/campus/search')
			},
			// 开启校招网申
			campusStart () {
				this.$router.push('/jobs/campus/remind')
				// window.location.href = process.env.VUE_APP_LINK + '/user_settings/net_application'
			},
			// 刷新页面数据
			refreshPageData (name) {
				if (name !== 'campus-detail' || !this.compRecruitInfos.length) {
					this.$refs.jobContainer.scrollY = 0
					this.awaitLoadingShow = true
					this.page = 1
					this._getCategories()
				}
			},
			// 跳转blog
			toCampusBlog () {
				window.location.href = process.env.VUE_APP_LINK + `/blog/4m4x2juz?from=qiuzhao`
			},
			// 上拉加载
			onPullingUp () {
				if (!this.isEnd) {
					this.page += 1
					this.loadingShow = true
					this._getCampusList()
				} else {
					this.$refs.scroll.forceUpdate()
				}
			},
			// 下拉刷新
			onPullingDown () {
				this.page = 1
				this._getCampusList(true)
			},
			// 切换职位tag
			async changeCategory (item, index) {
				// this.loadingShow = true
				this.page = 1
				this.compRecruitInfos = []
				this.loadingShow = false
				this.currentIndex = index
				this._getCampusList(true)
			},
			// 获取职位tag
			async _getCategories () {
			  this.categories = ['最新', '热门', '互联网', '金融', '咨询', '快消', '电子', '房地产', '其他']
              this.currentIndex = 0
              this._getCampusList(true)
			},
			// 获取校招网申列表
			async _getCampusList (refresh) {
			  console.log("fdajfsakjjdk")
				let category = this.categories[this.currentIndex]
				let payload = {
                  category,
                  page: this.page,
                  pagesize: 10
				}
				let res = await this.$api.jobs.getCompRecruitList(payload)
				if (res.code === 1000) {
					if (refresh) {
						this.compRecruitInfos = res.data.comp_recruit_infos
					} else {
						this.compRecruitInfos = [ ...this.compRecruitInfos, ...res.data.comp_recruit_infos ]
					}
					this.wechatAllNetApplicationOpened = res.data.wechat_self_net_application_opened
					this.isEnd = this.page*10 > res.data.total_count
					this.awaitLoadingShow = false
					if (this.isEnd) this.loadingShow = false
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .job-list {
    /*height: calc(var(--vh, 1vh) * 100 - 92px);*/
    background-color: #f8f8f8;
    .search-list {
      .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 6px;
        background-color: $color-light;
        height: 40px;
        padding: 0 16px;
        .title {
          font-size: $font-size-medium-x;
          color: $color-title;
          margin-right: 11px;
        }
        .desc {
          font-size: $font-size-small;
          color: #9c9c9c;
        }
        .theme-btn {
          width: 57px;
          height: 26px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: $color-theme;
          font-size: $font-size-medium;
          color: $color-light;
          border-radius: 2px;
          outline: none;
          border: none;
        }
        .prompt {
          font-size: $font-size-medium;
          color: $color-title;
          &::before {
            content: '';
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: $color-theme;
            vertical-align: middle;
            margin-right: 16px;
          }
          .gift {
            color: $color-theme;
          }
        }
      }
      .search-img {
        padding: 14px 16px 0 16px;
        background-color: $color-light;
        margin-top: 12px;
        .search-input {
          width: 100%;
          height: 36px;
        }
      }
      .type-content {
        position: sticky;
        top: 44px;
        width: 100vw;
        background-color: $color-light;
        .category-container {
          height: 46px;
          .type-item {
            margin-right: 32px;
            white-space: nowrap;
            color: $color-light-gray;
            font-size: $font-size-medium;
            &:last-child {
              /*padding-right: 16px;*/
              margin-right: 16px;
            }
            &:first-child {
              margin-left: 16px;
            }
          }
          .type-item-active {
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            color: $color-title;
            &::after {
              position: absolute;
              bottom: -16px;
              content: '';
              display: inline-block;
              width: 18px;
              height: 2px;
              background-color: $color-theme;
              border-radius: 1px;
            }
          }
        }
      }
      .the-line {
        width: 100vw;
        height: 1px;
        background-color: #f4f4f4;
      }
    }
  }
</style>
